export default __webpack_public_path__ + "static/media/InsuproLogoBlue.58e0e964.svg";